






























































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import Pagination from '@/components/Pagination.vue';
import AdminModule from '@/store/modules/Admin';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import { IUserSeamlessProblemResponse, IUserSeamlessProblemRequest } from '@/interface/Admin';

@Component({
  components: {
    Table,
    Pagination,
  },
})
export default class TransferKey extends Mixins(ErrorHandleMixin, PaginationMixin) {
  AdminInstance = getModule(AdminModule, this.$store);

  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Username',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Created date',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Created by',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Role',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Action',
      },
    ],
  ];

  Criteria: IUserSeamlessProblemRequest = {
    username: '',
    page: 1,
    limit: 100,
  };

  userList: Array<IUserSeamlessProblemResponse> = [];

  PaginationDetail = {
    current: 1,
    amount: 1,
    size: 100,
  };

  async created() {
    await this.fetchUser();
  }

  changePage(i: number) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.fetchUser();
  }

  async fetchUser() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.AdminInstance.FetchUser(this.Criteria);
    if (status.code) {
      this.checkError(status);
      this.userList = [];
    } else {
      this.userList = [...data.list];
      this.PaginationDetail.amount = Math.ceil(data.count / this.PaginationDetail.size);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  async addUser(data: IUserSeamlessProblemRequest) {
    this.GeneralInstance.toggleLoading(true);
    const { status } = await this.AdminInstance.AddUser(data);
    if (status.code) this.checkError(status);
    else this.fetchUser();
    this.GeneralInstance.toggleLoading(false);
  }

  async removeUser(item: IUserSeamlessProblemRequest) {
    this.GeneralInstance.toggleLoading(true);
    const { status } = await this.AdminInstance.removeUser(item);
    if (status.code) this.checkError(status);
    else this.fetchUser();
    this.GeneralInstance.toggleLoading(false);
  }

  async searchUser(user: IUserSeamlessProblemRequest) {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.AdminInstance.SearchUser(user);
    if (status.code) {
      this.checkError(status);
      this.userList = [];
    } else {
      this.userList = [...data];
    }
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.Criteria.page = 1;
    this.GeneralInstance.toggleLoading(false);
  }

  async handleSearch(username: string) {
    if (username) this.searchUser({ username });
    else this.fetchUser();
  }

  async handleAdd(username) {
    await this.addUser({ username });
  }
}
